<template>
  <accordion-panel
    class="winding-temperature-section__accordion"
    id="winding-temperature-charts"
    :collapsed.sync="collapsed"
  >
    <template #title>
      <strong>{{
        $t('engineering.water-on-paper.windings-temperature')
      }}</strong>
    </template>
    <b-row
      v-show="loading"
      class="my-5"
    >
      <b-col
        class="text-center"
        cols="12"
      >
        <s-loader size="lg" />
      </b-col>
    </b-row>
    <div v-show="!loading && windingTemperatureCharts.length">
      <b-row class="winding-temperature-section__subtitle-wrapper mb-2">
        <b-col
          class="winding-temperature-section__subtitle-content"
          v-for="(subtitle, subtitleIndex) in subtitles"
          cols="auto"
          sm="4"
          :key="subtitleIndex"
        >
          <div class="d-inline-block">
            <i
              class="fas fa-square-full mr-2"
              aria-hidden="true"
              :class="subtitle.class"
            ></i> {{ $t(`engineering.water-on-paper.subtitles.${subtitle.text}`) }}
          </div>
        </b-col>
      </b-row>
      <b-row class="winding-temperature-section__chart-wrapper">
        <b-col
          class="winding-temperature-section__chart"
          v-for="(windingChart, windingIndex) in windingTemperatureCharts"
          cols="auto"
          :xl="colsByWindings"
          :key="windingChart.windingId"
        >
          <winding-temperature-chart
            class="winding-temperature-section__chart-item"
            :chart-data="windingChart"
            :winding-id="windingIndex + 1"
            :is-collapsed="collapsed"
          />
        </b-col>
      </b-row>
    </div>
    <s-empty-list v-show="!loading && !windingTemperatureCharts.length" />
  </accordion-panel>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import WindingTemperatureChart from './WindingTemperatureChart';

export default {
  name: 'WindingTemperatureSection',
  components: {
    AccordionPanel,
    WindingTemperatureChart,
  },
  props: {
    windingTemperatureCharts: {
      type: Array,
      default: () => ([]),
    },
    windingAmount: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    collapsed: false,
  }),
  computed: {
    colsByWindings() {
      const maxColumns = 12;
      if (!this.windingAmount) return maxColumns;
      return maxColumns / this.windingAmount;
    },
    subtitles() {
      return [
        {
          class: 'primary',
          text: 'winding-temperature',
        },
        {
          class: 'orange',
          text: 'triggering-alarm-limit',
        },
        {
          class: 'danger',
          text: 'bubble-formation-alarm',
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .winding-temperature-section
    &__accordion
      border: 1px solid $color-border-gray
      border-radius: 5px
    &__chart-item
      min-width: 200px
      margin: 5px 0
    &__chart
      display: inline-flex
      flex-direction: column
      flex: 1
  .primary
    color: var(--color-primary)
    font-size: 1.1em
  .danger
    color: var(--color-danger)
    font-size: 1.1em
    opacity: .5
  .orange
    color: var(--color-secondary)
    font-size: 1.1em
    opacity: .5
  ::v-deep
    .accordion-panel
      &__header
        padding: 2px 15px !important
        font-weight: bold
</style>
